module.exports = __webpack_public_path__ + "img/icon_store_white.d469dbca.svg";